document.addEventListener("DOMContentLoaded", function () {
  // Inicializar Swiper solo en móviles
  if (window.innerWidth <= 768) {
    const swiper = new Swiper('.swiper-container', {
      slidesPerView: 'auto', // Ancho dinámico para las columnas
      //spaceBetween: 15, // Espacio entre las columnas
      loop: true, // Carrusel infinito
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },      
    });
  }
});